export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
  return (bytes / (1024 * 1024)).toFixed(1) + " MB";
}

export function classNames(...classes: (string | undefined | null)[]) {
  return classes.filter(Boolean).join(" ");
}

export function camelize(str: string) {
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
}

export const booleanCheck = (check: any) => Boolean(parseInt(check));

export function wordSeparate(str: string) {
  return str.replace(/_/g, " ");
}

export const checkMatch = (parentArray: string[], subsetArray: string[]) => {
  if (!subsetArray) {
    return false;
  }
  return subsetArray.every((el: any) => {
    return parentArray.includes(el);
  });
};

export const checkSubset = (parentArray: string[], subsetArray: []) => {
  return subsetArray.every((el) => {
    return parentArray.includes(el);
  });
};

export const camelToSnakeCase = (str: string) => {
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
};

export const normalizeRoleNames = (roles: any[]): string[] => {
  const arr = Array.isArray(roles) ? roles : [roles];
  return arr.map((r: any) => r?.name || r).filter(Boolean) as string[];
};

export const normalizeLocationIds = (locations: any[]): number[] => {
  return Array.isArray(locations) ? locations.map((l: any) => l.id).filter(Boolean) as number[] : [];
};

export const getToken = () => {
  return sessionStorage.getItem("cactoken") || localStorage.getItem("cactoken")
}

export const setToken = (token: string) => {
  sessionStorage.setItem('cactoken', token);
  localStorage.setItem('cactoken', token)
}
export const removeToken = () => {
  sessionStorage.removeItem("cactoken")
  localStorage.removeItem("cactoken")
  return
}

